import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const MessageModal = ({ isOpen, onClose, message, text = 'confirm'}) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}
            contentLabel="Message">
            <div>
                <div style={{ minWidth: '300px' }} className="flex-h flex-center">
                    <h1 className="f-200">Message</h1>
                </div>
                <div className="mt-16 mb-16" style={{ border: '1px solid #ddd', borderRadius: '20px' }}></div>
                <h3>{message}</h3>
                <button onClick={() => onClose()} className="mt-24 button is-success is-fullwidth center">{text}</button>
            </div>
        </Modal>
    );
}

export default MessageModal;